import { create } from "zustand"

export const alarmStore = create((set) => ({
  open: false,
  row: null,

  openModal: (row) => set({ open: true, row }),
  closeModal: () => set({ open: false, row: null })
}))
